import React from "react";
import { Card, CardBody, CardTitle, Button, Badge } from "reactstrap";
import { t } from "i18next";
import { useConfirmDialogStore } from "../../../stores/Modal/ConfirmDialogStore";

const OptionCard = ({ option, onDelete, onEdit }) => {
  const { showConfirm } = useConfirmDialogStore((state) => state);

  return (
    <Card
      className="shadow-lg p-1 rounded"
      style={{
        border: "none",
        backgroundColor: "#fff",
        transition: "0.3s ease-in-out",
      }}
    >
      <CardBody>
        <div className="d-flex justify-content-between align-items-center mb-2">
          <div>
            <CardTitle tag="h5" className="fw-bold text-dark">
              {option?.name} {option?.name_ar && `- ${option?.name_ar}`}
            </CardTitle>
          </div>
          <div className="d-flex gap-2">
            <Button
              size="sm"
              style={{ backgroundColor: "#c59253", borderColor: "#c59253" }}
              onClick={() => onEdit?.(option)}
              title={t("Edit")}
            >
              <i className="ri-edit-2-line"></i>
            </Button>
            <Button
              size="sm"
              color="danger"
              onClick={() =>
                showConfirm(
                  () => onDelete(option?.menu_item_option_id),
                  () => console.log("Cancelled"),
                  t("Confirmation"),
                  t("Are you sure you want to delete this option?")
                )
              }
              title={t("Delete")}
            >
              <i className="ri-delete-bin-fill"></i>
            </Button>
          </div>
        </div>

        <div className="d-flex flex-wrap gap-2">
          {option?.choices?.map((choice) => {
            const isDefault =
              option?.default_choice?.menu_item_option_choice_id ===
              choice?.menu_item_option_choice_id;
            const isAvailable = choice?.available ?? true;

            return (
              <Badge
                key={choice?.menu_item_option_choice_id}
                color={
                  isDefault ? "#c59253" : isAvailable ? "secondary" : "dark"
                }
                className={`px-3 py-2 rounded d-flex align-items-center gap-2 ${
                  isDefault
                    ? "text-light fw-bold"
                    : isAvailable
                    ? "text-light"
                    : "text-light"
                }`}
                style={{
                  fontSize: "0.9rem",
                  backgroundColor: isDefault
                    ? "#c59253"
                    : isAvailable
                    ? "#f8f9fa"
                    : "#f1f1f1",
                  border: isDefault ? "none" : "1px solid #ddd",
                }}
              >
                {choice?.name} {choice?.name_ar && `- ${choice?.name_ar}`}
                {isDefault && <i className="ri-star-fill ms-2"></i>}
                {!isAvailable && <i className="ri-eye-off-line ms-1"></i>}
              </Badge>
            );
          })}
        </div>
      </CardBody>
    </Card>
  );
};

export default OptionCard;
